import Cookie from '@wetransfer/concorde-cookie';
import Store from '@app/store';
import Config from '@app/config';
import Router from '@module/router';

export const init = () => {
  // Onboard first time users
  const teamOnboardedCookie = Config.cookies.teamOnboarded.name;
  let teamOnboardedValue;
  // If the team has not onboarded
  // Which means either the value is undefined/false
  if (!Cookie.get(teamOnboardedCookie)) {
    teamOnboardedValue = false;
  } else if (Cookie.get(teamOnboardedCookie) === 'false') {
    teamOnboardedValue = true;
  }

  // Set cookie if there is something to set
  if (teamOnboardedValue !== undefined || teamOnboardedValue) {
    Cookie.set(teamOnboardedCookie, teamOnboardedValue, {
      days: 365,
    });
  }

  // Don't do this on small windows (because it will force full panel)
  if (window.innerWidth <= 1050) {
    return;
  }

  // Only on homepage
  const { route } = Store.getState();
  if (route.path !== '/') {
    return;
  }

  // Not if the user signed out in the last 30 minutes
  if (Cookie.get(Config.cookies.signout.name)) {
    return;
  }

  const showPanel = () => {
    const { route } = Store.getState();
    if (!route.isPanelOpen) {
      Router.navigateTo('/sign-in', Router.SILENT);
    }
  };

  // Open panel if Plus user is not logged in
  const { user } = Store.getState();
  if (!user.loggedIn && Boolean(Cookie.get(Config.cookies.plus.name))) {
    setTimeout(showPanel, Config.panel.openDelay);
  }
};

init();
